(function () {
  'use strict';

  /* ── Wire ALL buy buttons to hero product ── */
  var heroVariantInput = document.getElementById('gs-global-variant');
  if (heroVariantInput) {
    var globalVariantId = parseInt(heroVariantInput.value, 10);
    if (globalVariantId) {
      document.querySelectorAll('[data-gs-buy]').forEach(function (btn) {
        btn.dataset.variant = String(globalVariantId);
        btn.style.display = '';
      });
    }
  }

  /* ── Scroll Reveal ── */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '-30px 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });

  /* ── Count-up ── */
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function animateCount(el) {
    if (el.dataset.animated) return;
    el.dataset.animated = '1';
    var target = parseFloat(el.dataset.target || el.textContent);
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var dec = parseInt(el.dataset.decimal || '0', 10);
    var start = performance.now();
    (function tick(now) {
      var p = Math.min((now - start) / 1600, 1);
      var val = easeOut(p) * target;
      el.textContent = prefix + (dec > 0 ? val.toFixed(dec) : Math.floor(val)) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = prefix + (dec > 0 ? target.toFixed(dec) : target) + suffix;
    })(start);
  }
  var countObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { animateCount(e.target); countObs.unobserve(e.target); } });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-count]').forEach(function (el) { countObs.observe(el); });

  /* ── Mobile nav ── */
  var hamburger = document.getElementById('gs-hamburger');
  var mobileNav = document.getElementById('gs-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', String(open));
      mobileNav.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        mobileNav.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Smooth scroll ── */
  var stickyHeader = document.querySelector('.gs-header');
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var offset = (stickyHeader ? stickyHeader.offsetHeight : 0) + 12;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    });
  });

  /* ── Magazine Gallery (auto-fetched product images) ── */
  var mainImg = document.getElementById('gs-main-img');
  function initGallery(selector) {
    var btns = document.querySelectorAll(selector);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        if (mainImg) {
          mainImg.style.opacity = '0.6';
          mainImg.src = this.dataset.src || this.dataset.img;
          mainImg.onload = function () { mainImg.style.opacity = '1'; };
        }
      });
    });
  }
  initGallery('.mag-thumb');
  initGallery('.gs-thumb'); /* fallback for manual-image galleries */

  /* ── Variant / Pack Selector ── */
  var variantOpts = document.querySelectorAll('.variant-opt');
  if (variantOpts.length) {
    variantOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (this.dataset.available === 'false' || this.disabled) return;
        variantOpts.forEach(function (o) { o.classList.remove('active'); o.setAttribute('aria-pressed', 'false'); });
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');
        var variantId = this.dataset.variantId;
        var price     = this.dataset.price;
        var compare   = this.dataset.compare;
        /* Update all buy buttons */
        document.querySelectorAll('[data-gs-buy]').forEach(function (btn) {
          btn.dataset.variant = variantId;
        });
        /* Update global variant input */
        var heroInput = document.getElementById('gs-global-variant');
        if (heroInput) heroInput.value = variantId;
        /* Update price display */
        var priceEl   = document.getElementById('gs-price-now');
        var compareEl = document.getElementById('gs-price-was');
        if (priceEl && price)   priceEl.textContent   = price;
        if (compareEl && compare) compareEl.textContent = compare;
      });
    });
  }

  /* ── Buy Now → direct checkout ── */
  document.querySelectorAll('[data-gs-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = this.dataset.variant;
      if (!variantId) return;
      var self = this;
      var orig = self.innerHTML;
      self.disabled = true;
      self.innerHTML = 'Processing&hellip;';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { self.disabled = false; self.innerHTML = orig; });
    });
  });

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (this.open) {
        document.querySelectorAll('.faq-item[open]').forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      }
    });
  });

})();
